import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ClaimStatusEnum, CrewMerchantApi } from 'corso-types';
import api from '~/api';
import {
  shippingClaimQueryKey,
  useShippingClaim,
} from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useStoreId } from '~/providers/StoreUserProvider';

export type ShippingClaimClose = CrewMerchantApi.RequestBody<
  '/:storeId/shipping-protection/claim/:shippingClaimId/close',
  'post'
>;

/** The only statuses a claim can be closed into, and so the only ones it can be restored from. */
export const shippingClaimCloseStatuses = [
  ClaimStatusEnum.closedDenied,
  ClaimStatusEnum.closedResolved,
] as const satisfies ShippingClaimClose['status'][];

export function useShippingClaimClose() {
  const storeId = useStoreId();
  const shippingClaim = useShippingClaim();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ShippingClaimClose) =>
      api
        .store(storeId)
        .shippingProtection.claim(`${shippingClaim.id}`)
        .close(body),
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: shippingClaimQueryKey(shippingClaim.id, storeId),
      });
      // the claims list shows status
      await queryClient.invalidateQueries({ queryKey: ['shippingClaims'] });
    },
  });
}
